import { BreadCrumbProvider } from "../../component/ui/breadcrumb";
import React, { useEffect } from "react";
import { Layout } from "../adminPage/Layout";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { getEmailTemplatesDropdown, getInvestorInfo, getInvestorsDropdown, getSchemesDropdown } from "../../utils/util";
import { setAllSchemeDetails } from "../../context/actions/allSchemeDetailsAction";
import { setAllInvestorDetails } from "../../context/actions/allInvestorDetailsAction";
import { setAllEmailTemplateDetails } from "../../context/actions/allEmailTemplateDetailsAction";

const Admin = () => {
  const dispatach=useDispatch()
  const userInfo=useSelector(state=>state.user)
  const allSchemeDetails=useSelector(state=>state.allSchemeDetails)
  const getAllSchemeDetails=async()=>{
    try {
      const response =await getSchemesDropdown()
      console.log("response for gett all schemes dropdown from admin index.js file ",response.data)
      if(response){
        dispatach(setAllSchemeDetails(response?.data));
      }
    } catch (error) {
      console.log("Error in get all schemes dropdown ",error)
    }
  }

  const getAllInvestorDetails=async()=>{
    const payload={
      // user_type:userInfo && userInfo.user_type
      user_type:"investor"
    }
    try {
      const response=await getInvestorsDropdown(payload)
      if(response){
        dispatach(setAllInvestorDetails(response?.data))
      }
    } catch (error) {
      console.log("Error in get all investor dropdown ",error)
    }
  }


  const getAllEmailTemplateDetails=async()=>{
    try {
      const response =await getEmailTemplatesDropdown()
      console.log("response for gett all Email Template dropdown from admin index.js file ",response.data)
      if(response){
        dispatach(setAllEmailTemplateDetails(response.data));
      }
    } catch (error) {
      console.log("Error in get all Email Temaplate dropdown ",error)
    }
  }



  useEffect(()=>{
    
    getAllInvestorDetails()
    getAllEmailTemplateDetails()
  },[userInfo])

  useEffect(()=>{
if(allSchemeDetails===null){
  getAllSchemeDetails()
}
  },)

  return (
    <>
      <BreadCrumbProvider>

        <Layout />
       
      </BreadCrumbProvider>
    </>
  );
};

export default Admin;
